import { ABSTRACT_API_KEY, ARIANE_MOVIE_ID } from "../index";
import { isClient } from "../utils/dev";

if (typeof ARIANE_MOVIE_ID === "undefined")
  console.error("ARIANE_MOVIE_ID is undefined");

const LOCATION_IP_API = `https://ipgeolocation.abstractapi.com/v1/?api_key=${ABSTRACT_API_KEY}`;
const toFreeGeoIpFormat = ({
  ip_address: ip,
  postal_code: zip_code,
  country: country_name,
  region_iso_code: region_code,
  region: region_name,
  timezone,
  ...o
}) => ({
  ip,
  zip_code,
  country_name,
  region_code,
  region_name,
  timezone,
  time_zone: timezone?.name,
  ...o,
});

const uuidv4 = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      ((window.crypto || window.msCrypto).getRandomValues(
        new Uint8Array(1)
      )[0] &
        (15 >> (c / 4)))
    ).toString(16)
  );

const getCookie = () => {
  const name = "cinemap_cookie=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  const value = uuidv4();
  const date = new Date();
  date.setTime(date.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);
  const expires = `expires= ${date.toUTCString()}`;
  document.cookie = `cinemap_cookie=${value};${expires};path=/`;
  return value;
};

const createSession = () => {
  if (!isClient) {
    return {};
  }

  const params = new URL(document.location).searchParams;

  return {
    url: window.location.href,
    hostname: window.location.hostname,
    device: navigator.userAgent,
    id: uuidv4(),
    getLocation: (() => {
      const throwe = (e) => {
        throw Error(e);
      };
      const cache = fetch(LOCATION_IP_API)
        .then((r) => (r.ok ? r.json().then(toFreeGeoIpFormat) : throwe()))
        .catch((err) =>
          console.warn("[createSession] Couldn't discover location", err)
        );

      return () => cache;
    })(),
    cookie: getCookie(),
    utm: Object.fromEntries(
      [...params].filter(([key]) => key.includes("utm_"))
    ),
    campaignId: params.get("campaign_id"),
    cinemapId: params.get("cinemap_id"),
    cinemapCampaign: params.get("cinemap_campaign"),
    cinemapContent: params.get("cinemap_content"),
    movieId: ARIANE_MOVIE_ID,
  };
};

const session = createSession();

const getSession = () => ({ ...session });
export default getSession;
